import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

export const USER_TYPE = {
  CLIENT: 2120,
  INSTRUCTOR: 2130,
  STAFF: 2160,
  MANAGER: 2170,
  ADMIN: 2180,
  ELEARNING_MANAGER: 2190,
  ELEARNING_STUDENT: 2191,
  STUDENT: 2196,
  SME: 2197,
};

export const USER_TYPE_READABLE = {
  CLIENT: globalTranslate('userTypeReadable.client'),
  INSTRUCTOR: globalTranslate('userTypeReadable.instructor'),
  STAFF: globalTranslate('userTypeReadable.staff'),
  MANAGER: globalTranslate('userTypeReadable.manager'),
  ADMIN: globalTranslate('userTypeReadable.admin'),
  ELEARNING_MANAGER: globalTranslate('userTypeReadable.elearningManager'),
  ELEARNING_STUDENT: globalTranslate('userTypeReadable.elearningStudent'),
  STUDENT: globalTranslate('userTypeReadable.student'),
  SME: globalTranslate('smeWorkspace.userTypeReadable'),
};
